var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { color, borderRadius, spacing, fontWeight, palette } from '../../constants';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  line-height: 20px;\n  height: 20px;\n  min-width: 24px;\n  font-size: 11px;\n  font-weight: ", ";\n  text-align: center;\n  text-transform: uppercase;\n  padding: 0 ", ";\n  background: ", ";\n  color: ", ";\n  * {\n    fill: ", ";\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  line-height: 20px;\n  height: 20px;\n  min-width: 24px;\n  font-size: 11px;\n  font-weight: ", ";\n  text-align: center;\n  text-transform: uppercase;\n  padding: 0 ", ";\n  background: ", ";\n  color: ",
    ";\n  * {\n    fill: ",
    ";\n  }\n"])), borderRadius.extraLarge, fontWeight.bold, spacing.tight, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : palette.neutral4;
}, function (_a) {
    var foregroundColor = _a.foregroundColor;
    return foregroundColor !== null && foregroundColor !== void 0 ? foregroundColor : color.theme.typography.ink;
}, function (_a) {
    var foregroundColor = _a.foregroundColor;
    return foregroundColor !== null && foregroundColor !== void 0 ? foregroundColor : color.theme.typography.ink;
});
export var Badge = function (props) {
    return React.createElement(Wrapper, __assign({}, props), props.children);
};
var templateObject_1;
//# sourceMappingURL=index.js.map